import { ROUTES } from 'constants/routes';
import { useAuthenticatedAxios } from 'hooks/useAuthenticatedAxios';
import { useMswManager } from 'lib/util/useMswManager';
import { useMutation } from 'react-query';
import { HrznGatewayMswBuilder } from 'stories/HrznGatewayMswBuilder';
import { mockStatusList } from '../../mocks/statusList';
import { useSnackbar } from 'notistack';

export const usePartnerGetStatusList = () => {
  const Axios = useAuthenticatedAxios();
  const { enqueueSnackbar } = useSnackbar();

  // Set up the mock for the status list endpoint with a resolver to handle the request
  useMswManager(
    HrznGatewayMswBuilder.create().post(
      ROUTES.PartnerGetStatusList,
      {
        data: mockStatusList
      }
    )
  );

  return useMutation(
    async (facilityIds: unknown[]) => {
      const { data } = await Axios({
        method: 'post',
        url: `?route=${ROUTES.PartnerGetStatusList}`,
        data: facilityIds
      });
      return data;
    },
    {
      onError: (error) => {
        enqueueSnackbar('Failed to fetch status list', { variant: 'error' });
      }
    }
  );
};
